<button
  class="btn btn-qundis-primary qundis-btn-layer1 w-100 mt-3 mb-5 d-flex justify-content-center align-items-center"
  [routerLink]="['user/new']"
  [queryParams]="{ formAction: 'create' }"
>
  <span class="me-2">Neuen Benutzer anlegen</span>
  <i class="bi bi-plus fs-2"></i>
</button>
<mat-accordion>
  <div class="panel-header-row">
    <span
      class="d-flex justify-content-between align-items-center w-100 mat-content mb-3"
    >
      <!-- Add padding to match expansion panel -->
      <div class="d-flex user-details">
        <div class="sort-name d-flex align-items-center qundis-inner-content">
          Benutzername
          <i
            class="bi bi-arrow-down-up ps-1 cursor-pointer"
            (click)="toggleSort('name')"
          ></i>
        </div>
        <div class="sort-role d-flex align-items-center qundis-inner-content">
          Benutzerrolle
          <i
            class="bi bi-arrow-down-up ps-1 cursor-pointer"
            (click)="toggleSort('role')"
          ></i>
        </div>
      </div>
      <div class="sort-status d-flex align-items-center qundis-inner-content">
        Status
        <i
          class="bi bi-arrow-down-up ps-1 cursor-pointer"
          (click)="toggleSort('status')"
        ></i>
      </div>
    </span>
  </div>

  <div *ngFor="let user of sortedUsers()">
    <!-- hide test users where firstName is '.' -->
    <mat-expansion-panel
      *ngIf="!(isProduction() && user.firstName === '.')"
      class="bg-qundis-grey-light"
    >
      <mat-expansion-panel-header class="bg-qundis-secundary-light">
        <mat-panel-title class="qundis-section-heading-h2">
          <div class="d-flex justify-content-between align-items-center w-100">
            <div class="d-flex user-details">
              <div class="user-name pt-0">
                {{ user.firstName }} {{ user.lastName }}
              </div>
              <div class="user-role btn pt-0">
                {{ user.userrole }}
              </div>
            </div>

            <div class="user-active">
              <div
                class="qundis-inner-content pe-3"
                style="pointer-events: none"
              >
                {{ user.isActive ? "Aktiv" : "Inaktiv" }}
                <span
                  class="state-indicator"
                  [ngClass]="{
                    active: user.isActive,
                    inactive: !user.isActive
                  }"
                >&#9679;</span
                >
              </div>
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <div class="workstation-details px-3 pt-4 qundis-inner-content">
          <p>Benutzername: {{ user.username }}</p>
          <p *ngIf="user.email">Email: {{ user.email }}</p>
          <p *ngIf="user.phone">Telefon: {{ user.phone }}</p>
          <p>Benutzerrolle: {{ user.userrole }}</p>
          <p *ngIf="user.userrole === Userrole.Teamleiter">
            zugeordnete Produktionslinie:
            {{ findProductionLine(user.productionLine!.split("%")[0]) }}
          </p>
        </div>
        <app-edit-delete-buttons
          [routeTo]="'user/' + user.id!"
          [itemToEdit]="'Benutzer'"
          [message]="'Soll der Benutzer wirklich gelöscht werden?'"
          (editEvent)="this.userDataService.userBeingEdited$.next(user)"
          (deleteEvent)="this.userDataService.delete$.next(user.id!)"
        >
        </app-edit-delete-buttons>
      </ng-template>
    </mat-expansion-panel>
  </div>
</mat-accordion>
